import { sentryLogger } from '../../../../monitor/monitor';
import { taskService } from '../../../../services';
import { refreshCriticalPathIsNeeded } from '../../events/onAfterAutoSchedule/refreshCriticalPathIsNeeded';

async function createTaskWithChild(dto) {
  const { gantt, task, parentId, parentProplannerId, t } = dto;
  window.to_use_react_gantt.creatingActivity = true;
  const currentParent = gantt.getTask(parentId);

  if (parentProplannerId) {
    try {
      let isIdAlreadyExist = false;

      window.stackActivitiesMotherSave.forEach((activity) => {
        if (activity === parentProplannerId) {
          isIdAlreadyExist = true;
        }
      });

      if (isIdAlreadyExist && !currentParent?.is_lookahead) {
        gantt.createTaskWithChildAction(task, parentId, parentProplannerId);
        return;
      }

      const tasksCount =
        await taskService.getTasksByActivityId(parentProplannerId);

      if (typeof tasksCount !== Number && tasksCount > 0) {
        gantt.showModalRemoveTaskLookahead(
          t,
          task,
          parentId,
          parentProplannerId
        );
        return;
      }
    } catch (err) {
      sentryLogger.warn('Error in gantt.createTaskWithChild', err);
    }
  }

  gantt.createTaskWithChildAction(task, parentId, parentProplannerId);

  refreshCriticalPathIsNeeded();
}

export { createTaskWithChild };
